jQuery('#calendarYear').change(function () {
    window.location = $(this).val();
});
